<template>
    <TemplatesSitesPage />
</template>
